<template>
  <div class="read-more-container">
    <p class="jm-text-center">
      {{ truncatedText }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ReadMoreText',
  props: {
    text: {
      type: String,
      required: true
    },
    shrinked: {
      type: Boolean,
      required: true
    },
    limit: {
      type: Number,
      default: 130
    }
  },
  computed: {
    truncatedText() {
      let text = this.text
      if (this.text.length > this.limit && this.shrinked) {
        for (let i = this.limit; i > 0; i--) {
          const currChar = this.text.charAt(i)
          const prevChar = this.text.charAt(i - 1)
          const prevCharNotPunc = [',', ';', '.'].some(c => c !== prevChar)
          if (currChar === ' ' && prevCharNotPunc) {
            text = `${this.text.substring(0, i)}...`
            break
          }
        }
      }
      return text
    },
    customClass() {
      return this.shrinked ? 'read-more-text-shrinked' : 'read-more-text'
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.read-more-text-shrinked {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
